import React from 'react';

interface LoaderProps {
  size?: 'sm' | 'md' | 'lg';
  containerClassName?: string;
  borderColorClass?: string;
}

export const Loader: React.FC<LoaderProps> = ({
  size = 'md',
  containerClassName = '',
  borderColorClass = 'border-[#0D373D]',
}) => {
  const sizeClasses = {
    sm: 'h-6 w-6',
    md: 'h-8 w-8',
    lg: 'h-10 w-10',
  };

  return (
    <div className={`flex items-center justify-center ${containerClassName}`}>
      <div
        className={`animate-spin rounded-full border-b-2 ${borderColorClass} ${sizeClasses[size]}`}
      />
    </div>
  );
};
